import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AiMessageIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AiMessage",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14 11c3.87 0 7-3.13 7-7 0 3.87 3.13 7 7 7-3.87 0-7 3.13-7 7 0-3.87-3.13-7-7-7"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21 19c-.55 0-1-.45-1-1 0-3.31-2.69-6-6-6-.55 0-1-.45-1-1s.45-1 1-1c3.31 0 6-2.69 6-6 0-.55.45-1 1-1s1 .45 1 1c0 3.31 2.69 6 6 6 .55 0 1 .45 1 1s-.45 1-1 1c-3.31 0-6 2.69-6 6 0 .55-.45 1-1 1m-3.13-8c1.31.73 2.4 1.82 3.13 3.13.73-1.31 1.82-2.4 3.13-3.13A8.1 8.1 0 0 1 21 7.87 8.1 8.1 0 0 1 17.87 11"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4 29c-.13 0-.26-.02-.38-.08C3.25 28.77 3 28.4 3 28V8c0-1.65 1.35-3 3-3h10c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1 .45-1 1v17.59l4.29-4.29a1 1 0 0 1 .71-.29h14c.55 0 1-.45 1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 1.65-1.35 3-3 3H10.41L4.7 28.72c-.19.19-.45.29-.71.29Z"
    })]
  }));
};